export default {"src":"/_next/static/media/RITM.45e118c3.svg","height":18,"width":18};